import { Badge, BadgeSize } from '@xemplo/badge';
import { DateFieldRhf } from '@xemplo/date-field';
import { PayrunExtended } from '@xemplo/gp-types';
import { DawnTime } from '@xemplo/icons';
import { SvgStroke } from '@xemplo/style-constants';
import { TimePickerRhf } from '@xemplo/time-picker';

import { formatCurrentValue } from '../edit-payrun-milestones.helpers';
import * as S from '../edit-payrun-milestones.styles';
import { MilestoneFieldConfig } from '../edit-payrun-milestones.types';

interface MilestoneRowProps {
  field: MilestoneFieldConfig;
  payrun: PayrunExtended;
}

export function MilestoneRow({ field, payrun }: Readonly<MilestoneRowProps>) {
  return (
    <S.Row>
      <S.RowDetails>
        <S.RowLabel>{field.label}</S.RowLabel>
        <S.RowCurrent>
          <Badge value="Current" size={BadgeSize.Small} />
          {formatCurrentValue(payrun, field)}
        </S.RowCurrent>
      </S.RowDetails>
      <DateFieldRhf
        name={`${field.key}.date`}
        aria-label={`${field.label} date`}
        placeholder="Select date"
        required
        rules={{
          required: 'Please select a date',
        }}
      />

      <TimePickerRhf
        leadingIcon={<DawnTime strokeWidth={SvgStroke.Light} />}
        name={`${field.key}.time`}
        aria-label={`${field.label} time`}
        placeholder="Select time"
        required
        rules={{
          required: 'Please select a time',
        }}
        readOnly={field.dateOnly}
      />
    </S.Row>
  );
}
